import { useMemo } from 'react';
import { useApp } from '@/components/hooks/useApp';
import { usePermissions } from '@/components/hooks/usePermissions';
import { useUserCompaniesCount } from '@/components/hooks/useUserCompaniesCount';
import { useOnboardingStatus } from '@/components/onboarding/useOnboardingStatus';

export function useNavigationContext() {
  const { user } = useApp();
  const { hasPermission } = usePermissions();
  const userCompaniesCount = useUserCompaniesCount();
  const { status } = useOnboardingStatus();
  const onboardingDone = !status || status.dismissed || status.completedCount >= status.totalSteps;
  return useMemo(() => ({ user, hasPermission, userCompaniesCount, onboardingDone }),
    [user, hasPermission, userCompaniesCount, onboardingDone]);
}
